import { createUserPreferencesService } from './UserPreferencesService.impl';

export const userPreferencesService = createUserPreferencesService();
